import { getGlobalArgs } from '@/root/global';
import { PageData } from '@/types/ssr';

import { equals } from './common';
import { skipFileExtension } from './navigation';

export const getSpecPath = (pageData: PageData, pathname: string) => {
  if (!pageData.spec) return '';

  const replacedCurPageToSpec = pathname.replace(pageData.current_page_name, pageData.spec);
  return `${getGlobalArgs('NEXT_PUBLIC_IMAGES_PROXY_URL', '')}${skipFileExtension('html', replacedCurPageToSpec)}`;
};

export const getFullCurrentPath = (location: Location, customPathName?: string) => {
  const { protocol, host, pathname } = location;
  return `${protocol}//${host}${customPathName || pathname}`;
};

export const isInvalidSlug = (slug: string) => equals(slug, '/') || equals(0, slug.length);
